import React, { useEffect } from "react";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import Heading from "../../components/Highlightedheading/Heading.jsx";
import AboutPageHeading from "../../components/AboutUs/AboutPageHeading.jsx";
import ClientSection2 from "../../components/Client/Section2.jsx";
import OurPartnerStatic from "../../components/OurPartnerStatic/index.jsx";
import { clients } from "../../assets/PartnersNew";
import contactImg from "../../assets/client/Banner.png";
import mobileImg from "../../assets/client/Banner_Mobile.png";
import { useWindowSize } from "react-use";
import BannerHeading from "../../components/BannerHeading/Heading";

export const Client = () => {
  const { width } = useWindowSize();
  const isMobile = width < 768;
  const isTablet = width >= 768 && width < 1024;
  useEffect(() => {
    const preloadImages = [contactImg, mobileImg];
    preloadImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="w-full h-full bg-[#0F221C] text-white">
      <div className="relative w-full  h-[90vh] md:h-[40vw] 3xl:h-[60vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent z-10">
          <div className="md:pl-[5.63vw] pl-4 flex items-center md:pt-[10.09vw] pt-[25vw]">
            <Pageheading pageHeading={"Clients"} icon={<RiHome2Line />} />
          </div>
        </div>
        <div
          className="absolute inset-0 bg-contain md:bg-cover bg-no-repeat bg-bottom flex justify-center items-center"
          style={{
            backgroundImage: `url(${isMobile ? mobileImg : contactImg})`,
          }}
        >
          <div className="absolute top-[25vh] md:top-[20vw] md:left-[17.47vw] flex justify-start items-center z-10">
            <BannerHeading headingText={"CLIENTS"} />
          </div>
        </div>
        <div className="absolute h-[250px] md:h-[300px] tab:h-[327px] w-full top-0 bg-gradient-to-b from-[#121614]"></div>
      </div>
      {/* <div className="px-[1vw] md:px-[6vw]  relative z-20">
        <AboutPageHeading headingText="WORK | LOVE | REPEAT" />
      </div>
     
      <div className="  md:px-[6vw]">
        <ClientSection2 />
      </div> */}
      <OurPartnerStatic heading={"work | love | repeat"} partners={clients} />
    </div>
  );
};

export default Client;
